import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../contexts/AuthContext';

export function useAdminCheck() {
  const { user } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      console.warn('[useAdminCheck] Loading timeout exceeded, forcing completion');
      setLoading(false);
      setIsAdmin(false);
    }, 3000);

    async function checkAdminStatus() {
      if (!user) {
        setIsAdmin(false);
        setLoading(false);
        clearTimeout(timeout);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('user_roles')
          .select('role')
          .eq('user_id', user.id)
          .maybeSingle();

        if (error) {
          console.error('Error checking admin status:', error);
          setIsAdmin(false);
        } else {
          setIsAdmin(data?.role === 'superadmin');
        }
      } catch (error) {
        console.error('Error checking admin status:', error);
        setIsAdmin(false);
      } finally {
        clearTimeout(timeout);
        setLoading(false);
      }
    }

    checkAdminStatus();

    return () => clearTimeout(timeout);
  }, [user]);

  return { isAdmin, loading };
}
